import api from 'Services/api'
import { UsuarioApi } from './types'

const USUARIO_BASE_URL = '/api/usuario'

const usuarioApiService = {
  list() {
    return api.get<UsuarioApi[]>(`${USUARIO_BASE_URL}/`)
  },
}

export default usuarioApiService
